import React from 'react'
import TealToolTip from 'components/TealToolTip'
import Icon from 'components/shared/Icon'

const InfoToolTipIcon = ({ title }) => (
  <TealToolTip {...{ title }} arrow placement='top' enterDelay={300}>
    <div>
      <Icon name='icon-information-outline' className='w6' />
    </div>
  </TealToolTip>
)

export default InfoToolTipIcon
